const $hero = $('#js-hero');

export default $hero;